import { render, staticRenderFns } from "./vehicleControl.vue?vue&type=template&id=70b5d2b9&scoped=true&"
import script from "./vehicleControl.vue?vue&type=script&lang=js&"
export * from "./vehicleControl.vue?vue&type=script&lang=js&"
import style0 from "./vehicleControl.vue?vue&type=style&index=0&id=70b5d2b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b5d2b9",
  null
  
)

component.options.__file = "vehicleControl.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VBtn,
  VDialog,
  VFlex,
  VIcon,
  VSelect,
  VSwitch,
  VTextField,
})
